module.exports = __webpack_public_path__ + "static/media/docketProject.fc09b58e.png";